import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { MachinePartActions } from 'redux/actions/settings/MachinePartActions';
import { ManufacturerActions } from 'redux/actions/settings/ManufacturerActions';
import { ModalActions } from "redux/actions/ModalActions";
import { UnitActions } from 'redux/actions/settings/UnitActions';

import { TableColumn, Table, TableRow } from 'app/components/common/Table';
import { StoreModel } from 'models/StoreModel';
import { LoginUser } from 'models/LoginUser';
import { MachinePart } from 'models/MachinePart';
import { Manufacturer } from 'models/Manufacturer';
import { Unit } from 'models/Unit';
import { PageContentHeader } from 'app/components/common/PageContentHeader';
import { Translations } from 'models/Translations';
import Translator from 'app/components/common/Translator';

interface Props {
    fetchMachineParts: typeof MachinePartActions.fetchMachineParts;
    fetchManufacturers: typeof ManufacturerActions.fetchManufacturers;
    fetchUnits: typeof UnitActions.fetchUnits;
    addMachinePartForm: typeof ModalActions.showModal;
    addMachinePart: typeof MachinePartActions.addMachinePart;
    editMachinePartForm: typeof ModalActions.showModal;
    editMachinePart: typeof MachinePartActions.editMachinePart;
    deleteMachinePart: typeof MachinePartActions.deleteMachinePart
    loginUser: LoginUser;
    machineParts: MachinePart[];
    manufacturers: Manufacturer[];
    units: Unit[];
    translations: Translations;
}

class MachineParts extends React.Component<Props> {
    componentDidMount() {
        if (this.loggedIn()) {
            if (!this.props.machineParts) {
                this.props.fetchMachineParts(this.props.loginUser.token);
            }
            if (!this.props.manufacturers) {
                this.props.fetchManufacturers(this.props.loginUser.token);
            }
            if (!this.props.units) {
                this.props.fetchUnits(this.props.loginUser.token);
            }
        }
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.machineParts && this.props.manufacturers && this.props.units
    }

    setMachinePartData(): TableRow[] {
        return this.props.machineParts.map(part => ({
            dataObject: {
                id: part.id,
                name: part.name,
                manufacturer: part.manufacturer,
                manufacturerPartNumber: part.manufacturerPartNumber,
                ean: part.ean,
                price: part.price,
                unit: part.unit,
                archivedDate: part.archivedDate
            }
        }));
    }

    setColumns(): TableColumn[] {
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'Machine Part',
                accessor: 'name',
            },
            {
                header: 'Manufacturer',
                accessor: 'manufacturer',
            },
            {
                header: 'manufacturerPartNumber',
                accessor: 'manufacturerPartNumber',
            },
            {
                header: 'ean',
                accessor: 'ean',
            },
            {
                header: 'price',
                accessor: 'price',
            },
            {
                header: 'Unit',
                accessor: 'unit',
            },
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Machine Parts" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Machine Parts" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addMachinePart}
                        addFormAction={this.props.addMachinePartForm}
                        addFormData={{
                            header: "Add a new Machine Part",
                            formObject: MachinePart.empty(),
                        }}
                        editAction={this.props.editMachinePart}
                        editFormAction={this.props.editMachinePartForm}
                        editFormData={{
                            header: "Edit Machine Part",
                        }}
                        deleteAction={this.props.deleteMachinePart}
                        selectConfigs={[
                            // 0 = machine-only manufacturer
                            { divId: 'manufacturer', filter: (m: object) => (m as Manufacturer).manufacturerType?.id !== 0 },
                            { divId: 'unit', filter: (u: object) => Unit.hasUsage(u as Unit, 'Part') }
                        ]}
                        optionals={['manufacturer', 'manufacturerPartNumber', 'ean', 'price', 'unit']}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setMachinePartData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        machineParts: state.machineParts,
        manufacturers: state.manufacturers,
        units: state.units,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchMachineParts: bindActionCreators(MachinePartActions.fetchMachineParts, dispatch),
        fetchManufacturers: bindActionCreators(ManufacturerActions.fetchManufacturers, dispatch),
        fetchUnits: bindActionCreators(UnitActions.fetchUnits, dispatch),
        addMachinePart: bindActionCreators(MachinePartActions.addMachinePart, dispatch),
        addMachinePartForm: bindActionCreators(ModalActions.showModal, dispatch),
        editMachinePart: bindActionCreators(MachinePartActions.editMachinePart, dispatch),
        editMachinePartForm: bindActionCreators(ModalActions.showModal, dispatch),
        deleteMachinePart: bindActionCreators(MachinePartActions.deleteMachinePart, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MachineParts);
